import $apiJSON from '../http/apiJSON'

// Music API Service

export async function getArtists(params = {}) {
  return $apiJSON.get('music/artists/', { params })
}

export async function getArtist(id) {
  return $apiJSON.get(`music/artists/${id}/`)
}

export async function getAlbums(params = {}) {
  return $apiJSON.get('music/albums/', { params })
}

export async function getAlbum(id) {
  return $apiJSON.get(`music/albums/${id}/`)
}

export async function getTracks(params = {}) {
  return $apiJSON.get('music/tracks/', { params })
}

export async function getTrack(id) {
  return $apiJSON.get(`music/tracks/${id}/`)
}

export async function listenTrack(id) {
  return $apiJSON.post(`music/tracks/${id}/listen/`)
}

export async function getPlaylists(params = {}) {
  return $apiJSON.get('music/playlists/', { params })
}

export async function getPlaylist(id) {
  return $apiJSON.get(`music/playlists/${id}/`)
}

export async function createPlaylist(data) {
  return $apiJSON.post('music/playlists/', data)
}
